// Project dates — Approved Baseline / Current Forecast / date Change Request (ProjectDates.jsx), Young 27/10 + Jay 28/10.
// EXF, SKU, DCR are terms and stay as they are.
const en = {
  season: "Season",
  proposedSeason: "Proposed season",
  seasonLockedHint: "The season is agreed — to change it, open Dates on the project and request a date change.",
  confirmFilter: "Original target to confirm ({{n}})",
  confirmFilterHint: "Approved projects whose original launch month and season nobody has confirmed yet",
  confirmBadge: "Confirm original",
  confirmBadgeHint: "The approved dates were taken from the portal on 28/Oct/2026 — the Project Owner still has to confirm the original target",
  confirmTitle: "Confirm the original target",
  confirmWhy: "The approved dates were taken from what the portal held on 28/Oct/2026. Give the launch month and season that were originally agreed.",
  confirmStart: "Confirm original target",
  confirmHint: "Once only. What you give here becomes the approved baseline; if the current forecast is later, the project shows as delayed. After this, only an approved date change request moves it.",
  origLaunch: "Original Target Launching",
  origSeason: "Original season",
  origSource: "Where it was agreed",
  origSourcePh: "e.g. Young's mail of 12/Aug, the 26FW season plan, the kick-off meeting",
  confirmSave: "Confirm",
  confirmDone: "Original target confirmed — it is now the approved baseline.",
  confirmedBy: "Original target confirmed by {{by}} · {{at}} — {{note}}",
  logOriginal: "the original target, confirmed by the Project Owner",
  countAll: "{{n}} requests",
  countOf: "{{n}} of {{total}}",
  allTeams: "All teams",
  searchPh: "Search request, project, SKU, person…",
  approveSel: "Approve selected ({{n}})",
  rejectSel: "Reject selected ({{n}})",
  clearSel: "Clear selection",
  tickAll: "Tick all shown",
  decideApprove: "Approve {{n}} request(s): {{ids}}",
  decideReject: "Reject {{n}} request(s): {{ids}}",
  colRequest: "Request",
  colProject: "Project",
  colTeam: "Team",
  colChange: "Change",
  colMoves: "Moves by",
  colAsked: "Asked",
  colReason: "Reason",
  colAction: "Action",
  launchShort: "Launch",
  exfMany: "EXF of {{n}} SKUs",
  shiftWk: "+{{n}} wk",
  shiftEarlier: "{{n}} wk earlier",
  shiftDays: "{{n}} days",
  doneApproved: "{{n}} approved — the approved dates have moved.",
  doneRejected: "{{n}} rejected — the approved dates stay.",
  failed: "{{n}} could not be saved: {{err}}",
  noMatch: "No request matches the filter.",
  open: "Dates",
  openTitle: "Approved dates, forecast and date change requests",
  title: "Dates — {{id}}",
  close: "Close",
  loading: "Loading…",
  delayed: "Delayed",
  delayedTitle: "The current forecast is later than the approved date (or has no date). It stays delayed until a date change is approved.",
  changePending: "{{id}} waiting",
  changePendingTitle: "A date change request is waiting for the CEO's decision",
  rule: "The approved date changes only when the CEO approves a date change request. The forecast is what the team expects now and can be edited as before; while it is later than the approved date, the project shows as delayed.",
  colWhat: "Date",
  colBaseline: "Approved baseline",
  colForecast: "Current forecast",
  colState: "Status",
  launch: "Target Launching",
  exfOf: "EXF · {{id}}",
  none: "—",
  noBaselineYet: "not set yet",
  onTrack: "On track",
  done: "Done",
  noSkus: "No approved SKU yet — EXF dates are agreed when the SKUs are approved.",
  openBox: "{{id}} is waiting for the CEO's decision — asked by {{by}} on {{at}}.",
  withdraw: "Withdraw",
  withdrawConfirm: "Withdraw {{id}}? It stays on the record as withdrawn.",
  newRequest: "Request a date change",
  newTitle: "New date change request",
  newHint: "Fill in only the dates you want to move. The CEO decides; until then the approved dates stay and a later forecast shows as delayed.",
  proposedLaunch: "Proposed Target Launching",
  proposedExf: "Proposed EXF",
  reason: "Reason for the change",
  impactSales: "Impact on sales",
  impactOrders: "Impact on orders",
  impactProduction: "Impact on production",
  impactHint: "At least one of the three.",
  keepOptions: "Options for keeping the original target",
  send: "Send to the CEO",
  sending: "Sending…",
  cancel: "Cancel",
  sent: "{{id}} sent to the CEO.",
  history: "Record",
  noHistory: "No date change request yet.",
  logTitle: "How the approved dates were set",
  logGoLive: "set from the date at go-live (28/Oct/2026)",
  logFirst: "set from the first date given",
  logCr: "moved by {{id}}",
  status_Pending: "Waiting",
  status_Approved: "Approved",
  status_Rejected: "Rejected",
  status_Withdrawn: "Withdrawn",
  askedBy: "Asked by {{by}} · {{at}}",
  decidedBy: "{{status}} by {{by}} · {{at}}",
  // approval screen
  listTitle: "Date change requests",
  listEmpty: "No date change request is waiting.",
  listHint: "Approving moves the approved dates and attaches this record to the project. Rejecting keeps them; the reason is recorded.",
  approve: "Approve",
  reject: "Reject",
  rejectReason: "Reason for rejection (required)",
  approveNote: "Note (optional)",
  confirmReject: "Reject",
  confirmApprove: "Approve",
  working: "Saving…",
  approvedMsg: "{{id}} approved — the approved dates have moved.",
  rejectedMsg: "{{id}} rejected — the approved dates stay.",
  from: "approved",
  to: "proposed",
  forecastNow: "forecast now",
  waitingYou: "{{n}} waiting for your approval",
  waitingProjects: "Project approvals: {{n}}",
  waitingChanges: "Date changes: {{n}}",
};
const ko = {
  season: "시즌",
  proposedSeason: "변경 희망 시즌",
  seasonLockedHint: "시즌이 확정되어 있습니다 — 변경하려면 프로젝트의 일정(Dates)에서 일정 변경을 요청하세요.",
  confirmFilter: "원래 목표 확인 필요 ({{n}})",
  confirmFilterHint: "원래 출시 월과 시즌이 아직 확인되지 않은 승인 프로젝트",
  confirmBadge: "원래 목표 확인",
  confirmBadgeHint: "기준 일정은 2026-10-28 포털 값으로 설정되었습니다 — 프로젝트 담당자가 원래 목표를 확인해야 합니다",
  confirmTitle: "원래 목표 확인",
  confirmWhy: "기준 일정은 2026-10-28 포털에 있던 값으로 설정되었습니다. 원래 합의된 출시 월과 시즌을 입력해 주세요.",
  confirmStart: "원래 목표 확인",
  confirmHint: "한 번만 가능합니다. 입력한 값이 승인된 기준 일정이 되며, 현재 예상 일정이 더 늦으면 지연으로 표시됩니다. 이후에는 승인된 일정 변경 요청으로만 바뀝니다.",
  origLaunch: "원래 Target Launching",
  origSeason: "원래 시즌",
  origSource: "합의 근거",
  origSourcePh: "예: 대표님 8/12 메일, 26FW 시즌 계획, 킥오프 회의",
  confirmSave: "확인",
  confirmDone: "원래 목표를 확인했습니다 — 승인된 기준 일정이 되었습니다.",
  confirmedBy: "원래 목표 확인: {{by}} · {{at}} — {{note}}",
  logOriginal: "프로젝트 담당자가 확인한 원래 목표",
  countAll: "{{n}}건",
  countOf: "{{total}}건 중 {{n}}건",
  allTeams: "전체 팀",
  searchPh: "요청·프로젝트·SKU·담당자 검색…",
  approveSel: "선택 승인 ({{n}})",
  rejectSel: "선택 반려 ({{n}})",
  clearSel: "선택 해제",
  tickAll: "표시된 항목 모두 선택",
  decideApprove: "{{n}}건 승인: {{ids}}",
  decideReject: "{{n}}건 반려: {{ids}}",
  colRequest: "요청",
  colProject: "프로젝트",
  colTeam: "팀",
  colChange: "변경 내용",
  colMoves: "변경 폭",
  colAsked: "요청자",
  colReason: "사유",
  colAction: "처리",
  launchShort: "출시",
  exfMany: "SKU {{n}}개 EXF",
  shiftWk: "+{{n}}주",
  shiftEarlier: "{{n}}주 앞당김",
  shiftDays: "{{n}}일",
  doneApproved: "{{n}}건 승인 — 기준 일정이 변경되었습니다.",
  doneRejected: "{{n}}건 반려 — 기준 일정이 유지됩니다.",
  failed: "{{n}}건 저장 실패: {{err}}",
  noMatch: "조건에 맞는 요청이 없습니다.",
  open: "일정",
  openTitle: "승인된 기준 일정, 현재 예상 일정, 일정 변경 요청",
  title: "일정 — {{id}}",
  close: "닫기",
  loading: "불러오는 중…",
  delayed: "지연",
  delayedTitle: "현재 예상 일정이 승인된 기준 일정보다 늦거나 비어 있습니다. 변경이 승인될 때까지 지연으로 표시됩니다.",
  changePending: "{{id}} 결재 대기",
  changePendingTitle: "일정 변경 요청이 대표님 결재를 기다리고 있습니다",
  rule: "승인된 기준 일정은 대표님이 일정 변경 요청을 승인할 때만 바뀝니다. 현재 예상 일정은 팀이 지금처럼 수정할 수 있으며, 기준 일정보다 늦으면 프로젝트가 지연으로 표시됩니다.",
  colWhat: "일정",
  colBaseline: "승인된 기준 일정",
  colForecast: "현재 예상 일정",
  colState: "상태",
  launch: "Target Launching",
  exfOf: "EXF · {{id}}",
  none: "—",
  noBaselineYet: "아직 없음",
  onTrack: "정상",
  done: "완료",
  noSkus: "승인된 SKU가 아직 없습니다 — EXF 일정은 SKU가 승인될 때 확정됩니다.",
  openBox: "{{id}} 대표님 결재 대기 중 — {{by}}, {{at}} 요청.",
  withdraw: "요청 취소",
  withdrawConfirm: "{{id}}을(를) 취소할까요? 기록에는 취소로 남습니다.",
  newRequest: "일정 변경 요청",
  newTitle: "새 일정 변경 요청",
  newHint: "바꾸려는 일정만 입력하세요. 대표님이 결정하며, 그 전까지는 기준 일정이 유지되고 더 늦은 예상 일정은 지연으로 표시됩니다.",
  proposedLaunch: "변경 희망 Target Launching",
  proposedExf: "변경 희망 EXF",
  reason: "변경 사유",
  impactSales: "매출 영향",
  impactOrders: "발주 영향",
  impactProduction: "생산 영향",
  impactHint: "세 가지 중 하나 이상.",
  keepOptions: "기존 목표를 지킬 수 있는 대안",
  send: "대표님께 결재 요청",
  sending: "보내는 중…",
  cancel: "취소",
  sent: "{{id}} 결재 요청을 보냈습니다.",
  history: "기록",
  noHistory: "일정 변경 요청이 아직 없습니다.",
  logTitle: "기준 일정이 정해진 내역",
  logGoLive: "도입 시점(2026-10-28)의 일정으로 설정",
  logFirst: "처음 입력된 일정으로 설정",
  logCr: "{{id}}로 변경",
  status_Pending: "결재 대기",
  status_Approved: "승인",
  status_Rejected: "반려",
  status_Withdrawn: "취소됨",
  askedBy: "요청: {{by}} · {{at}}",
  decidedBy: "{{status}}: {{by}} · {{at}}",
  listTitle: "일정 변경 요청",
  listEmpty: "결재를 기다리는 일정 변경 요청이 없습니다.",
  listHint: "승인하면 기준 일정이 바뀌고 이 결재 기록이 프로젝트에 남습니다. 반려하면 기준 일정이 유지되고 사유가 기록됩니다.",
  approve: "승인",
  reject: "반려",
  rejectReason: "반려 사유 (필수)",
  approveNote: "의견 (선택)",
  confirmReject: "반려",
  confirmApprove: "승인",
  working: "저장 중…",
  approvedMsg: "{{id}} 승인 — 기준 일정이 변경되었습니다.",
  rejectedMsg: "{{id}} 반려 — 기준 일정이 유지됩니다.",
  from: "기준",
  to: "희망",
  forecastNow: "현재 예상",
  waitingYou: "결재 대기 {{n}}건",
  waitingProjects: "프로젝트 승인 {{n}}건",
  waitingChanges: "일정 변경 {{n}}건",
};
const vi = {
  season: "Season",
  proposedSeason: "Season đề xuất",
  seasonLockedHint: "Season đã được chốt — muốn đổi thì mở Dates của project và gửi phiếu đổi ngày.",
  confirmFilter: "Cần xác nhận ngày gốc ({{n}})",
  confirmFilterHint: "Project đã duyệt mà chưa ai xác nhận tháng launch và season ban đầu",
  confirmBadge: "Xác nhận ngày gốc",
  confirmBadgeHint: "Ngày đã duyệt đang lấy theo dữ liệu portal ngày 28/10/2026 — Project Owner cần xác nhận mục tiêu ban đầu",
  confirmTitle: "Xác nhận mục tiêu ban đầu",
  confirmWhy: "Ngày đã duyệt đang lấy theo dữ liệu portal ngày 28/10/2026. Hãy nhập tháng launch và season đã chốt ban đầu.",
  confirmStart: "Xác nhận ngày gốc",
  confirmHint: "Chỉ làm một lần. Giá trị nhập ở đây thành ngày đã duyệt; nếu ngày dự kiến hiện tại muộn hơn thì project hiện là trễ. Sau đó chỉ phiếu đổi ngày được duyệt mới dời được.",
  origLaunch: "Target Launching ban đầu",
  origSeason: "Season ban đầu",
  origSource: "Đã chốt ở đâu",
  origSourcePh: "vd: mail của Young ngày 12/08, kế hoạch season 26FW, buổi kick-off",
  confirmSave: "Xác nhận",
  confirmDone: "Đã xác nhận mục tiêu ban đầu — đây là ngày đã duyệt.",
  confirmedBy: "Mục tiêu ban đầu do {{by}} xác nhận · {{at}} — {{note}}",
  logOriginal: "mục tiêu ban đầu, do Project Owner xác nhận",
  countAll: "{{n}} phiếu",
  countOf: "{{n}} / {{total}}",
  allTeams: "Tất cả team",
  searchPh: "Tìm phiếu, project, SKU, người gửi…",
  approveSel: "Duyệt các phiếu đã chọn ({{n}})",
  rejectSel: "Từ chối các phiếu đã chọn ({{n}})",
  clearSel: "Bỏ chọn",
  tickAll: "Chọn tất cả đang hiện",
  decideApprove: "Duyệt {{n}} phiếu: {{ids}}",
  decideReject: "Từ chối {{n}} phiếu: {{ids}}",
  colRequest: "Phiếu",
  colProject: "Project",
  colTeam: "Team",
  colChange: "Đổi gì",
  colMoves: "Dời",
  colAsked: "Người gửi",
  colReason: "Lý do",
  colAction: "Thao tác",
  launchShort: "Launch",
  exfMany: "EXF của {{n}} SKU",
  shiftWk: "+{{n}} tuần",
  shiftEarlier: "sớm {{n}} tuần",
  shiftDays: "{{n}} ngày",
  doneApproved: "Đã duyệt {{n}} phiếu — ngày đã duyệt đã dời.",
  doneRejected: "Đã từ chối {{n}} phiếu — ngày đã duyệt giữ nguyên.",
  failed: "{{n}} phiếu chưa lưu được: {{err}}",
  noMatch: "Không có phiếu nào khớp bộ lọc.",
  open: "Ngày",
  openTitle: "Ngày đã duyệt, dự kiến hiện tại và phiếu đổi ngày",
  title: "Ngày — {{id}}",
  close: "Đóng",
  loading: "Đang tải…",
  delayed: "Trễ",
  delayedTitle: "Ngày dự kiến hiện tại muộn hơn ngày đã duyệt (hoặc chưa có ngày). Vẫn tính là trễ cho tới khi phiếu đổi ngày được duyệt.",
  changePending: "{{id}} chờ duyệt",
  changePendingTitle: "Có phiếu đổi ngày đang chờ CEO quyết định",
  rule: "Ngày đã duyệt chỉ đổi khi CEO duyệt phiếu đổi ngày. Ngày dự kiến là ngày team đang tính, sửa như trước; khi nó muộn hơn ngày đã duyệt thì project hiện là trễ.",
  colWhat: "Ngày",
  colBaseline: "Ngày đã duyệt (Baseline)",
  colForecast: "Dự kiến hiện tại (Forecast)",
  colState: "Trạng thái",
  launch: "Target Launching",
  exfOf: "EXF · {{id}}",
  none: "—",
  noBaselineYet: "chưa có",
  onTrack: "Đúng hạn",
  done: "Xong",
  noSkus: "Chưa có SKU nào được duyệt — ngày EXF được chốt khi SKU được duyệt.",
  openBox: "{{id}} đang chờ CEO quyết định — {{by}} gửi lúc {{at}}.",
  withdraw: "Rút phiếu",
  withdrawConfirm: "Rút {{id}}? Phiếu vẫn nằm trong lịch sử với trạng thái đã rút.",
  newRequest: "Xin đổi ngày",
  newTitle: "Phiếu đổi ngày mới",
  newHint: "Chỉ điền những ngày muốn dời. CEO quyết định; trước đó ngày đã duyệt giữ nguyên và ngày dự kiến muộn hơn sẽ hiện là trễ.",
  proposedLaunch: "Target Launching đề xuất",
  proposedExf: "EXF đề xuất",
  reason: "Lý do đổi ngày",
  impactSales: "Ảnh hưởng tới sales",
  impactOrders: "Ảnh hưởng tới order",
  impactProduction: "Ảnh hưởng tới production",
  impactHint: "Ít nhất một trong ba.",
  keepOptions: "Phương án để giữ mục tiêu ban đầu",
  send: "Gửi CEO duyệt",
  sending: "Đang gửi…",
  cancel: "Hủy",
  sent: "Đã gửi {{id}} cho CEO.",
  history: "Lịch sử",
  noHistory: "Chưa có phiếu đổi ngày nào.",
  logTitle: "Ngày đã duyệt được đặt thế nào",
  logGoLive: "lấy theo ngày lúc áp dụng (28/10/2026)",
  logFirst: "lấy theo ngày đầu tiên được nhập",
  logCr: "dời theo {{id}}",
  status_Pending: "Chờ duyệt",
  status_Approved: "Đã duyệt",
  status_Rejected: "Từ chối",
  status_Withdrawn: "Đã rút",
  askedBy: "{{by}} gửi · {{at}}",
  decidedBy: "{{status}} bởi {{by}} · {{at}}",
  listTitle: "Phiếu đổi ngày",
  listEmpty: "Không có phiếu đổi ngày nào đang chờ.",
  listHint: "Duyệt thì ngày đã duyệt dời theo và phiếu này gắn vào project. Từ chối thì giữ nguyên ngày, lý do được lưu lại.",
  approve: "Duyệt",
  reject: "Từ chối",
  rejectReason: "Lý do từ chối (bắt buộc)",
  approveNote: "Ghi chú (không bắt buộc)",
  confirmReject: "Từ chối",
  confirmApprove: "Duyệt",
  working: "Đang lưu…",
  approvedMsg: "Đã duyệt {{id}} — ngày đã duyệt đã dời.",
  rejectedMsg: "Đã từ chối {{id}} — ngày đã duyệt giữ nguyên.",
  from: "đã duyệt",
  to: "đề xuất",
  forecastNow: "dự kiến hiện tại",
  waitingYou: "{{n}} việc chờ bạn duyệt",
  waitingProjects: "{{n}} project chờ duyệt",
  waitingChanges: "{{n}} phiếu đổi ngày",
};
const zh = {
  season: "季度",
  proposedSeason: "建议的季度",
  seasonLockedHint: "季度已确定 — 如需更改，请在项目的“日期”中提交日期变更申请。",
  confirmFilter: "待确认原始目标（{{n}}）",
  confirmFilterHint: "尚未确认原始上市月份和季度的已批准项目",
  confirmBadge: "确认原始目标",
  confirmBadgeHint: "批准日期取自 2026-10-28 门户中的数据 — 项目负责人仍需确认原始目标",
  confirmTitle: "确认原始目标",
  confirmWhy: "批准日期取自 2026-10-28 门户中的数据。请填写最初约定的上市月份和季度。",
  confirmStart: "确认原始目标",
  confirmHint: "仅可确认一次。此处填写的值将成为批准基准；若当前预计更晚，项目显示为延迟。此后只有获批的日期变更申请才能调整。",
  origLaunch: "原始 Target Launching",
  origSeason: "原始季度",
  origSource: "约定依据",
  origSourcePh: "例如：Young 8月12日的邮件、26FW 季度计划、启动会议",
  confirmSave: "确认",
  confirmDone: "已确认原始目标 — 现为批准基准。",
  confirmedBy: "原始目标由 {{by}} 确认 · {{at}} — {{note}}",
  logOriginal: "项目负责人确认的原始目标",
  countAll: "{{n}} 个申请",
  countOf: "{{n}} / {{total}}",
  allTeams: "全部团队",
  searchPh: "搜索申请、项目、SKU、人员…",
  approveSel: "批准所选（{{n}}）",
  rejectSel: "驳回所选（{{n}}）",
  clearSel: "取消选择",
  tickAll: "全选当前显示",
  decideApprove: "批准 {{n}} 个申请：{{ids}}",
  decideReject: "驳回 {{n}} 个申请：{{ids}}",
  colRequest: "申请",
  colProject: "项目",
  colTeam: "团队",
  colChange: "变更内容",
  colMoves: "调整幅度",
  colAsked: "申请人",
  colReason: "原因",
  colAction: "操作",
  launchShort: "上市",
  exfMany: "{{n}} 个 SKU 的 EXF",
  shiftWk: "+{{n}} 周",
  shiftEarlier: "提前 {{n}} 周",
  shiftDays: "{{n}} 天",
  doneApproved: "已批准 {{n}} 个 — 批准日期已调整。",
  doneRejected: "已驳回 {{n}} 个 — 批准日期不变。",
  failed: "{{n}} 个未能保存：{{err}}",
  noMatch: "没有符合筛选条件的申请。",
  open: "日期",
  openTitle: "批准日期、当前预计与日期变更申请",
  title: "日期 — {{id}}",
  close: "关闭",
  loading: "加载中…",
  delayed: "延迟",
  delayedTitle: "当前预计日期晚于批准日期（或没有日期）。在日期变更获批之前一直显示为延迟。",
  changePending: "{{id}} 待审批",
  changePendingTitle: "有日期变更申请等待 CEO 决定",
  rule: "批准日期只有在 CEO 批准日期变更申请时才会改变。当前预计由团队照常修改；只要晚于批准日期，项目即显示为延迟。",
  colWhat: "日期",
  colBaseline: "批准基准日期",
  colForecast: "当前预计",
  colState: "状态",
  launch: "Target Launching",
  exfOf: "EXF · {{id}}",
  none: "—",
  noBaselineYet: "尚未设定",
  onTrack: "正常",
  done: "已完成",
  noSkus: "尚无已批准的 SKU — EXF 日期在 SKU 获批时确定。",
  openBox: "{{id}} 正在等待 CEO 决定 — {{by}} 于 {{at}} 提交。",
  withdraw: "撤回",
  withdrawConfirm: "撤回 {{id}}？记录中会保留为已撤回。",
  newRequest: "申请变更日期",
  newTitle: "新的日期变更申请",
  newHint: "只填写要调整的日期。由 CEO 决定；在此之前批准日期不变，较晚的预计日期显示为延迟。",
  proposedLaunch: "建议的 Target Launching",
  proposedExf: "建议的 EXF",
  reason: "变更原因",
  impactSales: "对销售的影响",
  impactOrders: "对订单的影响",
  impactProduction: "对生产的影响",
  impactHint: "至少填写一项。",
  keepOptions: "保持原目标的方案",
  send: "提交 CEO 审批",
  sending: "提交中…",
  cancel: "取消",
  sent: "{{id}} 已提交给 CEO。",
  history: "记录",
  noHistory: "尚无日期变更申请。",
  logTitle: "批准日期的设定记录",
  logGoLive: "取自上线时（2026-10-28）的日期",
  logFirst: "取自首次填写的日期",
  logCr: "由 {{id}} 调整",
  status_Pending: "待审批",
  status_Approved: "已批准",
  status_Rejected: "已驳回",
  status_Withdrawn: "已撤回",
  askedBy: "{{by}} 提交 · {{at}}",
  decidedBy: "{{by}} {{status}} · {{at}}",
  listTitle: "日期变更申请",
  listEmpty: "没有待审批的日期变更申请。",
  listHint: "批准后批准日期随之调整，本记录附在项目上。驳回则保持原日期，并记录原因。",
  approve: "批准",
  reject: "驳回",
  rejectReason: "驳回原因（必填）",
  approveNote: "备注（选填）",
  confirmReject: "驳回",
  confirmApprove: "批准",
  working: "保存中…",
  approvedMsg: "{{id}} 已批准 — 批准日期已调整。",
  rejectedMsg: "{{id}} 已驳回 — 批准日期不变。",
  from: "批准",
  to: "建议",
  forecastNow: "当前预计",
  waitingYou: "{{n}} 项等待您审批",
  waitingProjects: "{{n}} 个项目审批",
  waitingChanges: "{{n}} 个日期变更",
};
const dictionary = { ns: 'xDates', en, ko, vi, zh };
export default dictionary;
